import { AdvanceShareCodeResponse, UpdateShareCodeRequest, UpdateShareCodeResponse } from '../services/models';

export type InitialSharebarState = {
  isLoading: boolean;
  hasError: boolean;
  error: Forbidden;
  sharecodeDetails: AdvanceShareCodeResponse;
};

export interface GetShareBarReqProps {
  sharecode?: string;
  sharecodeid?: string;
  projections: string;
}

export enum ApiProjections {
  ALL = 'ALL',
}

export enum EventsVersionsEnum {
  '1.0.0' = '1.0.0',
}

export type BaseUrlReqPayloadType = {
  baseUrl: string;
};

export type ProjectionReqPayloadType = {
  projections?: string;
};

export interface Forbidden {
  /**
   *
   * @type {string}
   * @memberof Forbidden
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof Forbidden
   */
  message?: string;
}

export type SharecodeReqPayloadType = {
  sharecodeid?: string;
  sharecode?: string;
};
export type SharecodePublishPayloadEventType = {
  payload: SharecodeEventPayloadType;
};
export type SharecodeEventPayloadType = {
  sharecodeid: string;
};
export type SharecodePublishEventType = SharecodePublishPayloadEventType & {
  event: string;
  sync?: boolean;
};

export type SharebarResponse = AdvanceShareCodeResponse | Forbidden;

export type SharecodeSubscribeEventType = {
  topics: string | string[];
  version: string;
  cb: (a: string, b: unknown) => void;
};

export type AddSharecodeReqPayloadType = {
  payload: AdvanceShareCodeResponse;
};

/* Customize Sharecode */
export type UpdateCustomSharecodeRequestPayloadType = {
  payload: UpdateShareCodeRequest;
};
export type UpdateCustomSharecodeResponsePublishPayloadEventType = {
  payload: UpdateCustomSharecodeResponseEventPayloadType;
};
export type UpdateCustomSharecodeResponseEventPayloadType = {
  sharecodeid: string;
  sharecode: string;
};
export type UpdateCustomSharecodePublishEventType = SharecodePublishPayloadEventType & {
  event: string;
  sync?: boolean;
};

export type UpdateCustomizeSharecodeResponse = UpdateShareCodeResponse | Forbidden;

export type UpdateCustomSharecodeSubscribeEventType = {
  topics: string | string[];
  version: string;
  cb: (a: string, b: unknown) => void;
};
